//@flow
import { defaultService } from './defaultService';
import { urlsConstants } from '../constants/url.constant';

export const reprocessarIntegracoesService = {
  reprocessarProdutos,
  consultar,
};

function reprocessarProdutos() {
  return defaultService.doPost(
    `${urlsConstants.API_REPROCESSAMENTO_INTEGRACAO}/PRODUTOS`,
    {},
  );
}

function consultar(protocolo) {
  return defaultService.doGet(
    `${urlsConstants.API_REPROCESSAMENTO_INTEGRACAO}/${protocolo}`,
  );
}
